import * as React from 'react';
import { lazyInject } from '../../services/inversify';
import { ApiService } from '../../services/api_service';
import { IDs } from '../../helpers/IDs';
import { WActionButton } from '../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { WSpinner } from '../../core/elements/spinner/WSpinner';

export interface ToolPruefungState {
    showSpinner: boolean;
    defectTools: any;
    fixedTools: any;
}

export class ToolPruefung extends React.Component<{}, ToolPruefungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showSpinner: false,
            defectTools: null,
            fixedTools: null,
        };
        this.checkTools = this.checkTools.bind(this);
        this.repairTools = this.repairTools.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;

    componentDidMount(): void {

    }

    render(): JSX.Element {
        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <WActionButton
                    label='Defekte Tools prüfen'
                    insideText='Defekte Tools prüfen'
                    tooltip='Defekte Tools prüfen'
                    action='suche'
                    onAction={this.checkTools}
                />
                <WActionButton
                    label='Defekte Tools reparieren'
                    insideText='Defekte Tools reparieren'
                    tooltip='Defekte Tools reparieren'
                    action='reload'
                    onAction={this.repairTools}
                />
            </div>
            {this.state.showSpinner && <WSpinner />}
            {this.state.defectTools && this.renderDefectTools()}
            {this.state.fixedTools && this.renderFixedTools()}
        </div>
    }

    getToolsRows(data: any) {
        const toolsMap: any = {};
        Object.keys(data).forEach((ent: string) => {
            if (Array.isArray(data[ent]) && data[ent].length > 0) {
                data[ent].forEach((r: any) => {
                    toolsMap[r.tid] = r;
                });
            }
        });
        const tools = Object.values(toolsMap);
        return tools;
    }

    renderDefectTools() {
        const defectTools = this.state.defectTools || {};

        const tools = this.getToolsRows(defectTools);
        if (tools.length === 0) {
            return <div style={{ padding: 10, fontSize: '0.9em' }}>Es gibt keine defekten Tools.</div>;
        }

        const ents: any = {
            konfiguration_none: {
                info: 'Tools mit fehlenden Konfigurationen'
            },
            konfiguration_multi: {
                info: 'Tools mit mehreren Konfigurationen'
            },
            unternehmensdaten_none: {
                info: 'Tools mit fehlenden Unternehmensdaten'
            },
            unternehmensdaten_multi: {
                info: 'Tools mit mehreren Unternehmensdaten'
            },
            standort_none: {
                info: 'Tools mit fehlenden Standorten'
            },
        };
        let cnt = 0;
        return <div style={{ padding: 10, fontSize: '0.9em' }}>
            {Object.keys(ents).map((ent: string, idx: number) => {
                const dataRows = defectTools[ent] || [];
                if (dataRows.length > 0) {
                    return <div key={`renderDefectTools_${idx}`} style={{ marginBottom: 20 }}>
                        <div style={{ margin: '10px 0', fontWeight: 'bold', padding: '5px 0', borderBottom: '2px solid black' }}>
                            {`${++cnt}. ${ents[ent].info}`}
                        </div>
                        <WFormsTableWrapper
                            entity={IDs.ENT_REGISTRIERUNG}
                            module={IDs.MOD_ETOOL_ADMIN}
                            data={dataRows}
                            customClass={'Custom-ETA'}
                            formLayout={'flowV2'}
                            hiddenColumns={['name', 'vorname', 'strasse', 'hausnummer', 'ort', 'plz', 'telefon', 'password_reset_requested', 'datum_del_account', 'password', 'schulung', 'newsletter_abo']}
                            tablePageSize={5}
                        />
                    </div>;
                }
                return null;
            })}
        </div>;
    }

    renderFixedTools() {
        const tools = this.getToolsRows(this.state.fixedTools || {});
        return tools.length > 0 ?
            <div style={{ padding: 10, fontSize: '0.9em' }}>
                <div style={{ margin: '10px 0', fontWeight: 'bold' }}>Die folgenden Tools wurden erfolgreich repariert.</div>
                <WFormsTableWrapper
                    entity={IDs.ENT_REGISTRIERUNG}
                    module={IDs.MOD_ETOOL_ADMIN}
                    data={tools}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    hiddenColumns={['name', 'vorname', 'strasse', 'hausnummer', 'ort', 'plz', 'telefon', 'password_reset_requested', 'datum_del_account', 'password', 'schulung', 'newsletter_abo']}
                    tablePageSize={5}
                />
            </div>
            : <div style={{ padding: 10, fontSize: '0.9em' }}>Es gibt keine defekten Tools.</div>;
    }

    checkTools() {
        this.setState({ showSpinner: true, defectTools: null, fixedTools: null }, () => {
            this.apiService.call('maintenance', { key2: 'checkBasisdata' }, (json: string, succ: boolean) => {
                this.setState({ showSpinner: false });
                // console.log(json, succ);
                if (succ) {
                    let obj;
                    try {
                        obj = JSON.parse(json);
                    } catch (e) {
                        console.error(e, json);
                    }
                    if (obj) {
                        this.setState({ defectTools: obj });
                    }
                }
            }, IDs.MOD_ETOOL_ADMIN);
        });
    }

    repairTools() {
        if (window.confirm('Wollen Sie defekte Tools automatisch reparieren lassen?')) {
            this.setState({ showSpinner: true, defectTools: null, fixedTools: null }, () => {
                this.apiService.call('maintenance', { key2: 'checkBasisdata', repair: true }, (json: string, succ: boolean) => {
                    this.setState({ showSpinner: false });
                    // console.log(json, succ);
                    if (succ) {
                        let obj;
                        try {
                            obj = JSON.parse(json);
                        } catch (e) {
                            console.error(e, json);
                        }
                        if (obj) {
                            this.setState({ fixedTools: obj });
                        }
                    }
                }, IDs.MOD_ETOOL_ADMIN);
            });
        }
    }
}
